module.exports = __webpack_public_path__ + "static/img/p3.94d89fa4.jpg";